<template>
  <div class="ask-for-transfer">
    <TitleBar :text="$t('AskForTransfer.topic')" :enableIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="body">
      <div class="text">{{ $t('AskForTransfer.message') }}</div>
      <div class="button-container">
        <button class="submit-btn" @click="clickCloseButton">{{ $t('AskForTransfer.cancel') }}</button>
        <button class="submit-btn" @click="clickTransferButton">{{ $t('AskForTransfer.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'AskForTransfer',
  components: {
    TitleBar
  },
  data () {
    return {
    }
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    clickTransferButton () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'Login',
        isTransfer: true
      })
    }
  }
}
</script>

<style scoped>
  .ask-for-transfer {
    height: fit-content;
    width: 320px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    padding: 16px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .body > .text {
    line-height: 1.75;
    margin-bottom: 8px;
  }

  .body > .button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .body > .button-container > button {
    width: calc((100% - 16px) / 2);
  }

  .submit-btn {
    width: 100%;
    padding: 6px;
    background: rgb(59, 144, 255);
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    margin: 8px 0px 8px 0px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/AskForTransfer.vue